import { PackStatus } from 'app/typings/core/admin/packs/enum/pack';

export const PACK_STATUS_LABELS: Record<PackStatus, string> = {
  [PackStatus.PUBLISHED]: 'Published',
  [PackStatus.SETUP]: 'Setup',
  [PackStatus.UNPUBLISHED]: 'Unpublished',
  [PackStatus.HIDDEN]: 'Hidden',
};

export const PACK_STATUS_DISPLAY_ORDER: Record<PackStatus, number> = {
  [PackStatus.PUBLISHED]: 0,
  [PackStatus.SETUP]: 1,
  [PackStatus.UNPUBLISHED]: 2,
  [PackStatus.HIDDEN]: 3,
};

export type PackStatusAction = 'publish' | 'setup' | 'unpublish' | 'hide';

// A pack can only move up one step at a time (HIDDEN -> UNPUBLISHED -> SETUP ->
// PUBLISHED), but it can be moved down to any lower status. Mirrors the
// transitions enforced by the core service.
const STATUSES_ALLOWING_ACTION: Record<PackStatusAction, PackStatus[]> = {
  publish: [PackStatus.SETUP],
  setup: [PackStatus.PUBLISHED, PackStatus.UNPUBLISHED],
  unpublish: [PackStatus.PUBLISHED, PackStatus.SETUP, PackStatus.HIDDEN],
  hide: [PackStatus.PUBLISHED, PackStatus.SETUP, PackStatus.UNPUBLISHED],
};

// The old data model has no setup step, so a pack goes straight from
// UNPUBLISHED to PUBLISHED.
const LEGACY_STATUSES_ALLOWING_ACTION: Record<PackStatusAction, PackStatus[]> =
  {
    publish: [PackStatus.UNPUBLISHED],
    setup: [],
    unpublish: [PackStatus.PUBLISHED, PackStatus.HIDDEN],
    hide: [PackStatus.PUBLISHED, PackStatus.UNPUBLISHED],
  };

export const canApplyPackStatusAction = (
  action: PackStatusAction,
  status: PackStatus,
  isLegacy = false
) =>
  (isLegacy ? LEGACY_STATUSES_ALLOWING_ACTION : STATUSES_ALLOWING_ACTION)[
    action
  ].includes(status);
